import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { FeaturesGrid } from '../components/FeaturesGrid';
import { ProvidersSection } from '../components/ProvidersSection';
import { HowItWorks } from '../components/HowItWorks';
import { ArchitectureDiagram } from '../components/ArchitectureDiagram';
import { SocialProof } from '../components/SocialProof';
import { DemoForm } from '../components/DemoForm';
import { Footer } from '../components/Footer';

export default function LandingPage() {
  return (
    <div className="min-h-full">
      <Header />
      <main>
        <Hero />
        <ProblemSection />
        <FeaturesGrid />
        <ProvidersSection />
        <HowItWorks />
        <ArchitectureDiagram />
        <SocialProof />
        <DemoForm />
      </main>
      <Footer />
    </div>
  );
}
